// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from "lodash";

type TableHeadingProps = {
    className?: string
}

export default function TableHeading(props: TableHeadingProps) {
    const {className, ...rest} = props;
    let clazz = `divTableHeading ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/TableHeading.js